import * as React from 'react';

import IndexLayout from '../layouts/index';

const IndexPage = () => <IndexLayout />;

export default IndexPage;
